module.exports = __webpack_public_path__ + "static/media/email.79b8d580.svg";